import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/CAP/mw-components-logo.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLine } from './components/QuoteLine';
import { EstimatedQuantityOnHand } from './components/QuoteLine/EstimatedQuantityOnHand';
import { PartDescription } from './components/QuoteLine/PartDescription';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

export function DefaultQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo
          source={logo}
          text="AS9100 Registered"
          // Extra styles can be added to fine tune the logo
          extraStyles={[{ height: '42px' }]}
        />

        {/* Some sites may have a different ecommerce site */}
        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation showFOB />
      </QuoteDetails>

      {quoteLines.map((line) => {
        return (
          <QuoteLine key={line.id} {...line} showDrawing>
            <PartId {...line.part} source={line.snapQuoteLineSource} />

            {/* Most site display description */}
            <PartDescription description={line.part.description} />

            <PartSpecs specs={line.specs} />

            {/* Most sites do not display quantity */}
            <EstimatedQuantityOnHand />
          </QuoteLine>
        );
      })}

      <Specs />

      <EmployeeInformation />

      {/* The rest of this is completely custom per site */}

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text>FOB:</Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.textSmall}>
            CERTIFICATION, FAIR & PPAP CHARGES (If required):
          </Text>
          <Text style={styles.textSmall}>
            Certificate of Conformance: $35.00/ purchase order line item
          </Text>
          <Text style={styles.textSmall}>
            Material Cert: $30.00/ purchase order line item
          </Text>
          <Text style={styles.textSmall}>
            Inspection Report: $75.00/ purchase order line item
          </Text>
          <Text style={styles.textSmall}>FAIR (AS9102): $500.00</Text>
          <Text style={styles.textSmall}>
            PPAP: $750.00 Other Certifications are quoted upon request.
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={[styles.bold, styles.textSmall]}>
            Block Tolerances DO NOT APPLY to items on this quotation. Commercial
            tolerances per DIN 2089 will apply if not otherwise referenced on
            the drawing. We reserve the right to pass through increases in
            material, energy, freight and/or outside service cost in effect at
            the time of manufacture. Items ordered as part of a blanket or
            multiple release agreement must be taken with 12 months manufacture.
            Quoted delivery subject to material availability at time of order.
            DFAR items subject to material availability at time of order. To
            prevent any problems, parts not previously manufactured will have a
            quality assurance review prior to the start of production
          </Text>
        </View>
      </View>
    </Page>
  );
}
